<div class="gb-edit-category">
  <form [formGroup]="categoryForm">
    <gb-form-field
      [control]="label"
      label="ITEMS.CATEGORY.NAME"
      required
      labelTranslateKey="ITEMS.CATEGORY.NAME_LABEL"
    ></gb-form-field>
  </form>

  <div class="items-select-container">
    <div class="search-container">
      <gb-search [isDialog]="true" label="ITEMS.LIST.SEARCH" (searchTermEmit)="onSearch($event)"></gb-search>
    </div>
    <gb-table
      [tableData$]="items$"
      [totalItemCount]="count$ | async"
      [displayedColumns$]="getDisplayColumns$(itemType)"
      [enableSelect]="true"
      [loaded$]="loaded$"
      [inDialog]="true"
      [selectedItems]="selectedItems"
      (checkboxChangeEvent)="onCheckboxChange($event)"
      [loaded$]="loaded$"
    >
    </gb-table>
    <mat-paginator
      #paginator
      [pageSize]="limit$ | async"
      [length]="count$ | async"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>

    <div class="selected-count">
      <span
        translate="ITEMS.CATEGORY.ITEMS_SELECTED"
        [translateParams]="{
          count: selectedItems.length,
        }"
      ></span>
    </div>
  </div>
</div>

<ng-template #itemType let-data>
  <gb-item-type-chip [item]="data.item"></gb-item-type-chip>
</ng-template>
